export default __webpack_public_path__ + "static/media/pass-circle-color.20f37ee4.svg";